import * as React from 'react';
import {useState} from 'react';
import axiosApiInstance from "../../../api/axiosClient";
import {Button, notification, Tooltip} from "antd";
import {ModalForm} from '@ant-design/pro-components';
import {FileExcelOutlined} from "@ant-design/icons";
import {useAtom} from "jotai";
import {releasesViewAtom} from "./ddex_atoms";
import {searchCriteriaAtom} from "./SearchForm";

type Props = {
    id?: number
};

const ExportReleasesExcel = (props: Props) => {
    const [exporting, setExporting] = useState(false)
    const [releasesView] = useAtom(releasesViewAtom);
    const [searchCriteria] = useAtom(searchCriteriaAtom);

    const exportExcel = () => {
        setExporting(true)
        notification.info({message: 'Operation started'})
        const params: Record<string, unknown> = {
            is_pending: releasesView == 'pending',
        };
        for (const [key, value] of Object.entries(searchCriteria)) {
            if (key === 'page' || key === 'pageSize' || key === 'sorter_field' || key === 'sorter_order') {
                continue;
            }
            if (value == null || value === '') {
                continue;
            }
            if (Array.isArray(value) && value.length === 0) {
                continue;
            }
            params[key] = value;
        }
        return axiosApiInstance.post(`/api/products/releases/export`, null, {
            params,
            // headers: {
            //     "Accept": "*/*",
            //     'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            //     Authorization: `Bearer ${access_token}`
            // },
            responseType: 'blob',
        })
            .then(res => {
                //download
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'releases.xlsx');
                document.body.appendChild(link);
                link.click();

                // sleep for 1 second
                // setTimeout(() => {
                // }, 1000);

                notification.success({message: 'Exported successfully'})
                setExporting(false)
                return true

            }).catch(reason => {
                setExporting(false)
                return false
            })
    }

    return (
        <ModalForm
            width={400}
            title={"Export Releases to excel?"}
            trigger={
                <Tooltip title={'Export to excel'}>
                    <Button type={"text"} icon={<FileExcelOutlined/>}
                        // icon={<DeleteOutlined/>}
                    />
                </Tooltip>
            }
            submitter={{submitButtonProps: {loading: exporting}}}
            autoFocusFirstInput
            modalProps={{
                destroyOnClose: true,
                okText: 'Yes',
                cancelText: 'No'
            }}
            onFinish={async (values) => {
                return exportExcel()
            }}
        >
            {/*Export Creators to excel?*/}
        </ModalForm>
    );
};

export default ExportReleasesExcel;